import { types, Instance } from 'mobx-state-tree';

export const Labels = types.model({
  orderComments: types.maybeNull(types.string),
  emailOptIn: types.maybeNull(types.string),
  termsBody: types.maybeNull(types.string),
  expressDivider: types.maybeNull(types.string),
});
export interface ILabels extends Instance<typeof Labels> {}
